import { render } from "./ObjectLinkValue.vue?vue&type=template&id=10d3c429"
import script from "./ObjectLinkValue.vue?vue&type=script&lang=js"
export * from "./ObjectLinkValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__